import React, { useEffect, useState } from "react";
import { TabContent, TabPane } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";
import { toast } from "react-toastify";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import ChannelsTab from "./ChannelsTab";

import {
  createSmmPostChannelStatus,
  createSmmPostChannelStatusSuccess,
  deleteSmmPostChannelStatus,
  fetchSmmPostChannelStatusList,
  updateSmmPostChannelStatus,
  updateSmmPostChannelStatusSuccess,
} from "../../../../store/socialMediaManagement/action";

export default function SocialMediaManagementSettings() {
  const dispatch = useDispatch();

  const { postChannelStatusListAPI, postChannelStatusListLoading } =
    useSelector((state) => ({
      postChannelStatusListAPI:
        state.socialMediaManagementReducer.postChannelStatusList
          ?.socialmediapoststatus_list,
      postChannelStatusListLoading:
        state.socialMediaManagementReducer.postChannelStatusListLoading,
    }));
  useEffect(() => {
    dispatch(fetchSmmPostChannelStatusList());
  }, []);
  const [statusList, setStatusList] = useState([]);
  // Task 24873 - the panel had one tab's worth of content and no tab strip.
  // Channels sits FIRST because it is the thing a company has to fill in
  // before anything else on the social screens does anything; statuses ship
  // with sensible defaults.
  const [activeTab, setActiveTab] = useState("channels");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [statusFlag, setStatusFlag] = useState(false);
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    FlagActive: null,
    FlagInvoiceable: null,
  });
  const [updateItemStatus, setUpdateItemStatus] = useState({});
  const handleCreateNewStatus = () => {
    if (activeTab === "statuses") {
      // Job Status create
      dispatch(createSmmPostChannelStatus([createStatus]));
    }
  };
  // Job Status create
  const { postChannelStatusCreateSuccessAPI } = useSelector((state) => ({
    postChannelStatusCreateSuccessAPI:
      state.socialMediaManagementReducer.postChannelStatusCreateSuccess,
  }));

  useEffect(() => {
    if (isEmpty(postChannelStatusCreateSuccessAPI)) return;
    if (postChannelStatusCreateSuccessAPI.status === 200) {
      toast.success(postChannelStatusCreateSuccessAPI.message);
      dispatch(fetchSmmPostChannelStatusList());
      setCreateStatus({
        Name: "New Status",
        CssColourText: "#000000",
        CssColourBackground: "#F4F0F0",
        FlagActive: null,
        FlagInvoiceable: null,
      });
    } else {
      toast.error(postChannelStatusCreateSuccessAPI.message);
    }
    dispatch(createSmmPostChannelStatusSuccess([]));
  }, [postChannelStatusCreateSuccessAPI]);

  const handleDeleteStatus = () => {
    if (activeTab === "statuses") {
      // Job Status delete
      dispatch(deleteSmmPostChannelStatus([deleteStatus]));
    }
  };

  // Delete Job Status
  const { postChannelStatusDeleteSuccessAPI } = useSelector((state) => ({
    postChannelStatusDeleteSuccessAPI:
      state.socialMediaManagementReducer.postChannelStatusDeleteSuccess,
  }));

  useEffect(() => {
    if (isEmpty(postChannelStatusDeleteSuccessAPI)) return;
    if (postChannelStatusDeleteSuccessAPI.status === 200) {
      toast.success(postChannelStatusDeleteSuccessAPI.message);
      dispatch(fetchSmmPostChannelStatusList());
      setDeleteModal(false);
    } else {
      toast.error(postChannelStatusDeleteSuccessAPI.message);
    }
    dispatch(updateSmmPostChannelStatusSuccess([]));
  }, [postChannelStatusDeleteSuccessAPI]);

  // Sort Data by active tab
  useEffect(() => {
    let data;
    if (activeTab === "statuses") {
      data = postChannelStatusListAPI?.sort((a, b) => b.Id - a.Id);
      setStatusFlag(true);
    }

    setStatusList(data);
  }, [postChannelStatusListAPI, activeTab]);

  const [deleteModal, setDeleteModal] = useState(false);

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      FlagActive: updateItemStatus?.FlagActive,
      FlagInvoiceable: updateItemStatus?.FlagInvoiceable,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "statuses") {
        // Job Status update

        dispatch(updateSmmPostChannelStatus([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  // Update Job Status
  const { postChannelStatusUpdateSuccessAPI } = useSelector((state) => ({
    postChannelStatusUpdateSuccessAPI:
      state.socialMediaManagementReducer.postChannelStatusUpdateSuccess,
  }));
  useEffect(() => {
    if (isEmpty(postChannelStatusUpdateSuccessAPI)) return;
    if (postChannelStatusUpdateSuccessAPI.status === 200) {
      toast.success(postChannelStatusUpdateSuccessAPI.message);
      dispatch(fetchSmmPostChannelStatusList());
    } else {
      toast.error(postChannelStatusUpdateSuccessAPI.message);
    }
    dispatch(updateSmmPostChannelStatusSuccess([]));
  }, [postChannelStatusUpdateSuccessAPI]);

  return (
    <>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteStatus}
        onCloseClick={() => {
          setDeleteModal(false);
        }}
      />
      <SettingsPanel
        title="Social Media Management Settings"
        description="The accounts you post to, and the statuses a post moves through."
        tabs={[
          { value: "channels", label: "Channels", slug: "channels" },
          { value: "statuses", label: "Post Statuses", slug: "post-statuses" },
        ]}
        value={activeTab}
        onChange={setActiveTab}
      >
        <TabContent activeTab={activeTab} className="pt-4">
          <TabPane tabId="channels">
            {/* Mounted only when selected: it fires two list calls, and there
                is no reason to make them when somebody came here for
                statuses. */}
            {activeTab === "channels" ? <ChannelsTab /> : null}
          </TabPane>
          <TabPane tabId="statuses">
            <StatusViewEditComponent
              statusList={statusList}
              setStatusList={setStatusList}
              createStatus={createStatus}
              setCreateStatus={setCreateStatus}
              handleCreateNewStatus={handleCreateNewStatus}
              setDeleteStatus={setDeleteStatus}
              setDeleteModal={setDeleteModal}
              setUpdateItemStatus={setUpdateItemStatus}
              statusFlag={statusFlag}
            />
          </TabPane>
        </TabContent>
      </SettingsPanel>
    </>
  );
}
